const { default: callApi } = require("helpers/callApi");

export const getAllDashboardDetails = async()=>{
    return await callApi(`admin_dashboard/get_admin_dashboard_details`)
}